var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.question.renderTemplate === "Template9"
    ? _c("div", { staticClass: "navbuttons", class: { hidden: this.isHidden } })
    : _c("div", { staticClass: "navbuttons" }, [
        _c("div", {
          staticClass: "progress-bar",
          class: [this.question.renderTemplate === "Template6" ? "light" : ""],
          style: _vm.progressBarStyle,
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            class: { disabled: this.isAnswerMax },
            attrs: { id: "buttonsWrapper" },
          },
          [
            _vm.quizData.navBtns
              ? _c(
                  "button",
                  {
                    staticClass: "prev-button",
                    attrs: { "aria-label": this.question.prevQuestion.title },
                    on: { click: _vm.prevQuestion },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.images.prev,
                        alt: this.question.prevQuestion.title,
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "title ti-fs-16 mb-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    this.isResultsPage
                      ? this.stepSelectionText
                      : this.question.stepTitle
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            !this.isResultsPage && _vm.quizData.navBtns
              ? _c(
                  "button",
                  {
                    staticClass: "next-button",
                    class: { disabled: this.nextButtonDisabled },
                    attrs: { "aria-label": this.question.nextQuestion.title },
                    on: { click: _vm.skipQuestion },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.images.next,
                        alt: this.question.nextQuestion.title,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }